import { defineMessages } from 'react-intl';

export default defineMessages({
    driverNotInHouseholdLabel: {
        id: 'quoteandbind.ea.views.ea-driver-details-not-in-household.Not in Household:',
        defaultMessage: 'Not in Household'
    }
});
